/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MakeCallRequest } from '../models/MakeCallRequest';
import type { MakeCallResponse } from '../models/MakeCallResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class OutboundCallControllerService {
    /**
     * @param xAiAgentOrganizationContext
     * @param requestBody
     * @returns MakeCallResponse OK
     * @throws ApiError
     */
    public static makeCall(
        xAiAgentOrganizationContext: string,
        requestBody: MakeCallRequest,
    ): CancelablePromise<MakeCallResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/call/outbound',
            headers: {
                'x-ai-agent-organization-context': xAiAgentOrganizationContext,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
